import { useSelector } from 'react-redux';

interface UseAppListing {
  aclQueryMode: string;
  currentPage: number;
  layout: string;
  selectedCardId: number;
  sortCriteria: string;
  totalItems?: number;
  totalPages?: number;
}

export function useAppListing(): UseAppListing {
  const listing = useSelector((state: any) => state.app.listing);
  return listing as UseAppListing;
}
